export const FOLDER_MIME = 'application/vnd.eti.folder-file';

// Bookmark rows from the Bookmarks app share the docket table and must be
// excluded everywhere in the File Library.
export const BOOKMARK_MIMES = [
  'application/vnd.eti.bookmark',
  'application/vnd.eti.folder-bookmark',
  'application/vnd.eti.folder-bookmarks',
];

/**
 * Legacy upload sentinel: the polymer app sent UUID=1231234123 as the group id
 * header on upload, so old rows carry it as pvGlobalGroupID. They remain visible
 * to every group ("cause of fear of losing old files", per the original source).
 */
export const LEGACY_GROUP_SENTINEL = '1231234123';

/**
 * The legacy rep-ui file library bucket (its FileUploadAPI `BUCKET`): stored
 * keys are `<timestamp>__<file name>` and the REP API presigns them from here.
 */
export const LEGACY_BUCKET = 'fallbackbucket';

/** Rows a page of the File Library table: the Equipment list's page size. */
export const FILE_LIBRARY_PAGE_SIZE = 10;
